module.exports = __webpack_public_path__ + "img/polygon.b046e893.png";